export default {
    install(Vue) {
        Vue.directive('transition-dependent-focus', {
            inserted: function (el) {
                const textFields = el.querySelectorAll('input');
                const textField = textFields.length > 0 ? textFields[textFields.length - 1] : textFields[0];
                if (!textField)
                    return;
                const setFocus = () => { textField.focus(); el.removeEventListener('transitionend', setFocus, false); };
                el.addEventListener('transitionend', setFocus, false);
            }
        });
    }
};
